<template>
  <div class="support-page">
    <h1>Support</h1>
    <h4>We're here to help!</h4>
    <ul class="list-unstyled help">
      <li>
        <router-link to="/contact" class="btn btn-choice contact">
          <img class="title-icon" src="@/assets/icons/mail_gray_60.png"/>
          Contact us
        </router-link>
      </li>
      <li v-if="tokenManager.current.isValid">
        <button type="button" class="btn btn-choice feedback" @click="onFeedbackClick">
          <img src="@/assets/icons/megaphone.svg"/>
          Feedback
        </button>
      </li>
    </ul>
    <router-link :to="{ name: 'faq' }">
      Frequently Asked Questions
    </router-link>

    <h4>Downloads</h4>
    <router-link to="/syncapp" class="btn btn-link link-dark syncapp">
      <img src="@/assets/logos/Sync_app.png"/>
      <div>Sync app</div>
    </router-link>

    <h4>Community</h4>
    <ul class="list-unstyled resources">
      <li class="facebook">
        <a href="https://www.facebook.com/groups/1484810245417258" target="_blank" @click="trackClick('support_community_facebook', { section: 'community', id: 'community_facebook', target: 'https://www.facebook.com/groups/1484810245417258' })">
          <img src="@/assets/logos/Facebook.png"/>
          Facebook <span class="no-break">Group <ExternalLinkIcon size="0.9x"/></span>
        </a>
      </li>
      <li class="discord">
        <a href="https://discord.gg/mFkGM5fH7b" target="_blank" @click="trackClick('support_community_discord', { section: 'community', id: 'community_discord', target: 'https://discord.gg/mFkGM5fH7b' })">
          <img src="@/assets/logos/Discord.svg"/>
          <div>Discord <span class="no-break">Server <ExternalLinkIcon size="0.9x"/></span></div>
        </a>
      </li>
    </ul>

  </div>
</template>
<style lang="scss" scoped>
.support-page {
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
}

h4 {
  margin: 1rem 0 0;
  color: rgb(214, 96, 33);
}

ul.help {
  display: flex;
  gap: 1rem;
}

.btn-choice {
  border-radius: 10px;
  padding: 1rem 1rem;
  font-size: 1.1rem;

  &.contact img {
    margin-right: 0.25rem;
    width: 1.8rem;
    filter: brightness(0) saturate(100%) invert(63%) sepia(76%) saturate(5097%) hue-rotate(184deg) brightness(100%) contrast(94%);
  }

  &.feedback img {
    width: 1.8rem;
    margin-right: 0.25rem;
    filter: invert(1) brightness(0.5) sepia(1) hue-rotate(15deg) saturate(8) brightness(1.2);
  }
}

p {
  max-width: 900px;
}

.feather-external-link {
  transform: translateY(-2px);
}

.no-break {
  white-space: nowrap;
}

.syncapp {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #888 !important;

  img {
    width: 50px;
  }
}

.resources {
  display: flex;
  gap: 1rem;

  li a {
    max-width: 100px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 60px auto;
    align-items: center;
    justify-items: center;
    font-size: 0.875rem;
    text-align: center;
    color: #666;

    svg {
      color: #333;
    }

    img {
      width: 50px;
    }

    &:hover {
      color: var(--bs-primary);
    }

    &:not(:hover) img {
      filter: saturate(0.7);// brightness(1.5);
    }
  }
}

.sharing-bar {
  img {
    width: 2rem;
  }

  a {
    margin-right: 20px;
  }
}
</style>
<script setup lang="ts">
import { usePageTitle } from '@webapp/util/AppUtil'
import { ExternalLinkIcon } from '@zhuowenli/vue-feather-icons'
import { useTokenManager } from '@/auth/TokenManager'
import { exchangeTokenAsync } from '@/auth/LocalTokenApi'
import { trackClick } from '@/util/Analytics'

const tokenManager = useTokenManager()

usePageTitle("Support")

function onFeedbackClick() {
  trackClick('support_feedback', { section: 'contact', id: 'support_feedback', target: 'https://treecrossing.sleekplan.app' })
  void onFeedback()
}

async function onFeedback() {
  const userToken = tokenManager.current.token
  try {
    const sleekToken = await exchangeTokenAsync(userToken, "https://app.sleekplan.com", '')
    const sleekUrl = `https://treecrossing.sleekplan.app/?sso=${encodeURIComponent(sleekToken.access_token)}`

    const popup = window.open(sleekUrl, '_blank', 'noopener')
    if (!popup) {
      window.location.assign(sleekUrl)
    }
  } catch {
    // No-op: if token exchange fails, remain on current page.
  }
}
</script>